
import * as actions from 'actions';

const INITIAL_STATE = {
  visible: false,
  query: ''
};

export default (state = INITIAL_STATE, action) => {
  switch(action.type) {
    case actions.SEARCH_SHOW:
      return {...state, query: '', visible: true};

    case actions.SEARCH_HIDE:
      return {...state, visible: false};

    case actions.SEARCH_UPDATE_QUERY:
      return {...state, query: action.query};

    default:
      return state;
  }
};



/** WEBPACK FOOTER **
 ** ./src/members/state/search/bar/reducer.js
 **/